module.exports = __webpack_public_path__ + "img/content-tongli.c1b6d86f.png";